import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import AnonymousLayout from "../../components/AnonymousLayout/AnonymousLayout";
import UserContext from "../../context/UserContext/UserContext";

const AnonymousRoute = ({ children }) => {
  const user = useContext(UserContext)[0];

  if (user && user.set_password_required) {
    return <Navigate to="/account" replace />;
  }

  if (user) {
    return <Navigate to="/organisation" replace />;
  }

  return <AnonymousLayout>{children}</AnonymousLayout>;
};

export default AnonymousRoute;
